import styled from 'styled-components';
import { LabelRegularM } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const InformationTextCont = styled(LabelRegularM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[70]};
  `}
`;
